
    export class DateFormatDirective implements ng.IDirective {

        public require = 'ngModel';
        public $filter: any;

        public link = (elem: any, $scope: any, attrs: any, ngModel: any) => {
            ngModel.$formatters.push((val: any) => {
                return this.$filter('date')(val, 'yyyy-MM-dd');
            });
        }

        public static $inject = ['$filter'];
        constructor($filter: any) {
            this.$filter = $filter;
        }

    }
